import { Component, input, viewChild } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
  selector: 'app-tooltip',
  imports: [MatIcon, MatTooltip],
  templateUrl: './app-tooltip.component.html'
})
export class AppTooltipComponent{
  tooltip = input<string>();

  component = viewChild(MatTooltip);
}
